export const stdoutSendLog = async (data: Record<string, unknown>) =>
  fetch(`/log?data=${JSON.stringify({ ...data })}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });
